var _circle, _path, _path2, _path3, _path4, _circle2, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrainers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 75,
    viewBox: "0 0 48 24",
    fill: "none",
    stroke: "#FF1493",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "mb-4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 3,
    fill: "#FF69B4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21v-4a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v4",
    stroke: "#FF6347"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11h14",
    stroke: "#FF1493"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 22v-5H8a2 2 0 0 0-2 2v3",
    stroke: "#FF6347"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22v-5h2a2 2 0 0 1 2 2v3",
    stroke: "#FF6347"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 7,
    r: 2.5,
    fill: "#FF69B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43 21v-3a3 3 0 0 0-3-3H31a3 3 0 0 0-3 3v3",
    stroke: "#FF6347"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31 14h12",
    stroke: "#FF1493"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33 21v-4h-1.5a1.5 1.5 0 0 0-1.5 1.5v2.5",
    stroke: "#FF6347"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39 21v-4h1.5a1.5 1.5 0 0 1 1.5 1.5v2.5",
    stroke: "#FF6347"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainers);
export default __webpack_public_path__ + "static/media/trainers.e44fe0cb11426b97471036b4f633aa4c.svg";
export { ForwardRef as ReactComponent };